<template>
	<div></div>
</template>

<script>
import { mapActions } from 'vuex';
import router from '@/router';

export default {
	name: 'OidcCallback',
	methods: {
		...mapActions('oidcStore', ['oidcSignInCallback'])
	},
	mounted() {
		this.oidcSignInCallback()
			.then(redirectPath => {
				router.push(redirectPath);
			})
			.catch(err => {
				console.error(err);
				router.push({ name: 'oidc-callback-error' });
			});
	}
};
</script>
